/**
 * Sample data for the 'Bloom Pro' template.
 * Tailored for modern, light-theme industrial and manufacturing websites.
 */

export const bloomProSample = {
  company: {
    id: "sample-bloom-tech",
    name: "Bloom Precision Engineering",
    tagline: "High-Tolerance Aerospace & Precision Components",
    headline: "Engineered for Extreme Reliability & Accuracy",
    description: "Bloom Precision Engineering specializes in multi-axis CNC milling, Swiss turning, and custom sheet metal fabrication for aerospace, defence, and medical device sectors. Operating state-of-the-art facilities with CMM inspection labs.",
    location: "Peenya Industrial Area, Bengaluru, Karnataka",
    city: "Bengaluru",
    state: "Karnataka",
    address: "Plot 34, 3rd Phase, Peenya Industrial Area, Bengaluru - 560058",
    logo_url: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=200&h=200&fit=crop&q=80",
    cover_url: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=1600&q=80",
    category: "Precision Engineering",
    mobile: "+91 93800 36328",
    whatsapp: "+91 93800 36328",
    email: "contact@bloomprecision.com",
    website: "https://bloomprecision.indianindustrialplatform.com",
    gst: "29AABCU9603R1ZM",
    year_established: 2012,
    delivery_area: "Pan-India & Global Export",
    certifications: [
      { name: "ISO 9001:2015", description: "Certified Quality Management Systems across design and manufacturing operations." },
      { name: "AS9100D Aerospace", description: "Stringent quality standard for aviation, space, and defense organizations." },
      { name: "ZED Gold Certified", description: "Zero Defect Zero Effect manufacturing certified by Govt. of India." }
    ],
    catalog_heading: "Precision Component Catalog"
  },
  products: [
    {
      id: "prod-b1",
      name: "5-Axis Titanium Impeller Hub",
      category: "Aerospace Machining",
      image_url: "https://images.unsplash.com/photo-1581092160607-ee22621dd758?w=800&q=80",
      price: "₹45,000",
      moq: "5 Pieces",
      description: "Ti-6Al-4V grade 5 alloy machined on simultaneous 5-axis Mazak machining center with ±5 micron tolerance."
    },
    {
      id: "prod-b2",
      name: "Hydraulic Valve Block Assembly",
      category: "Hydraulics",
      image_url: "https://images.unsplash.com/photo-1504917599217-d4dc5ebe6122?w=800&q=80",
      price: "₹18,500",
      moq: "10 Pieces",
      description: "Ductile iron hydraulic manifold block with pressure tested ports up to 350 bar."
    },
    {
      id: "prod-b3",
      name: "Precision Planetary Gearhead",
      category: "Automation & Robotics",
      image_url: "https://images.unsplash.com/photo-1581092335397-9583fe92d232?w=800&q=80",
      price: "₹24,000",
      moq: "2 Units",
      description: "Backlash less than 3 arc-min, hardened alloy gears with ground tooth profiles for industrial robotic arms."
    }
  ],
  posts: [
    {
      id: "post-b1",
      content: "Installation of our new DMG Mori 5-axis CNC Machining Center completed at Plant 2.",
      media_urls: ["https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&q=80"]
    }
  ],
  reels: []
};
